var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"distributingDevOpsPage mainPageBg"},[_c('DevOpsPublicCom',{attrs:{"system":'配电系统'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }